"use client";

import { useEffect } from "react";

import { buildWjsEmbedScriptUrl } from "~/lib/widget-script";

/**
 * Injects the same production widget as customer embeds: `/w.js?id=…`
 */
function removeEasygptWidgetShell() {
  ["easygpt-launcher", "easygpt-iframe-container", "easygpt-widget-container"].forEach(
    (id) => document.getElementById(id)?.remove(),
  );
  document
    .querySelectorAll('script[src*="/w.js?id="],script[src*="/w-v2.js?id="]')
    .forEach((el) => el.remove());
}

export function BuilderWjsPreview({
  projectId,
  enabled = true,
  reloadKey = 0,
  builderPreview = true,
}: {
  projectId: string;
  enabled?: boolean;
  /** Increment to remount the embed after onboarding import completes. */
  reloadKey?: number;
  /** When true, w.js shows launcher only (hire builder). Public profiles use false. */
  builderPreview?: boolean;
}) {
  useEffect(() => {
    if (!projectId || !enabled) {
      removeEasygptWidgetShell();
      return;
    }

    removeEasygptWidgetShell();

    const script = document.createElement("script");
    script.id = "easygpt-script-builder-preview";
    script.async = true;
    script.src = buildWjsEmbedScriptUrl(window.location.origin, projectId, {
      variantB: true,
      reloadKey,
      builderPreview,
    });
    document.head.appendChild(script);

    return () => {
      document.getElementById("easygpt-script-builder-preview")?.remove();
      removeEasygptWidgetShell();
    };
  }, [projectId, enabled, reloadKey, builderPreview]);

  return null;
}
